import App from '../app/App'
import Query from '../app/Query'

export class EventResource {
  constructor() {
    this.$app = App.instance
    this.$api = this.$app.$api
    this.$resource = this.$app.$resource
  }

  getEventsByEventTypeId(type_id) {

  }

  async getEventsByEventTypeIds(type_ids = []) {
    let query = (new Query('events'))
      .add('event_type_ids', type_ids)
      .add('include_property_records', true)
      .add('sort_field', 'created_at')
      .add('sort_direction', 'DESC')
      .add('count', 1000)

    return await this.$app.$memory(query.route,{
      action: 'carecloud_api',
      route: query.route
    })
  }

  async getBloodSampleEvents() {

    return await this.getEventsByEventTypeIds(['8ccacd16928931fd2fe06facd2', '8cc89f128a48808e4eb9721a86'])

  }

}
